const de = {
  dokumente: 'keine | 1 Dokument | {count} Dokumente',
  suchergebnisse: 'keine Suchergebnisse | ein Suchergebnis | {count} Suchergebnisse',
};

export default de;
